// Compact header

// ON SCROLL



function manageScrolling(){
  const body = document.querySelector('body');
  var header = document.getElementById('header');
  var scrollPos = window.scrollY || window.scrollTop || document.querySelector('html').scrollTop;
  if (scrollPos < 50) {
    header.classList.remove('header--compact');
  } else {
    header.classList.add('header--compact');
  }  
}

window.addEventListener('scroll', manageScrolling);
manageScrolling();




// ScrollTrigger plugin
gsap.registerPlugin(ScrollTrigger);

const leadCaptureHeroImage = document.querySelector('.layered-image--lead-capture-hero');
if(leadCaptureHeroImage) {

    gsap.fromTo(".background, .outside",
      { yPercent: 0, xPercent: 0 },
      {
        yPercent: -5,
        xPercent:0,
        scrollTrigger: {
          trigger: ".layered-image--lead-capture-hero",
          start: "top 0%",
          end: "bottom 0%",
          scrub: true
        }
      }
    );

    gsap.fromTo(".outside-2",
      { yPercent: 0, rotation: 0 },
      {
        yPercent: -5,
        rotation:-15,
        scrollTrigger: {
          trigger: ".layered-image--lead-capture-hero",
          start: "top 0%",
          end: "bottom 0%",
          scrub: true
        }
      }
    );

}

const leadCaptureHeroCrumbs = document.querySelector('.lead-capture-hero__crumbs');
if(leadCaptureHeroCrumbs) {
    gsap.fromTo(".lead-capture-hero__crumbs",
      { yPercent: 3 },
      {
        yPercent: -8,
        scrollTrigger: {
          trigger: ".lead-capture-hero__crumbs",
          start: "top 15%",
          end: "bottom 0%",
          scrub: true
        }
      }
    );
}


const benefitsImage = document.querySelector('.layered-image--benefits');
if(benefitsImage) {
    gsap.fromTo(".background, .outside",
      { yPercent: 10, xPercent: 5 },
      {
        yPercent: -3,
        xPercent:-1,
        scrollTrigger: {
          trigger: ".layered-image--benefits",
          start: "top 80%",
          end: "bottom 0%",
          scrub: true
        }
      }
    );
}

window.addEventListener("load", () => {
  ScrollTrigger.refresh();
});

/*
const scrollingTags = document.getElementById('scrolling-tags-track');
if(scrollingTags){
  gsap.fromTo("#scrolling-tags-track", { xPercent: 25 }, { xPercent: -25, duration: 40, ease: "none", repeat:-1 });
}
*/


// Shared variant ID for the free jar line item (used by both the Klaviyo signup
// redirect flow below and the Founder Subscribe / Just The Free Jar buttons)
var freeJarVariantId = 59703166402846;


// Coming Soon Signup form handling

window.addEventListener("klaviyoForms", async (event) => {

  if (event.detail.type !== "submit") return;

  if(event.detail.metaData?.$source == 'Coming Soon Signup' ){
    
    const email = event.detail.metaData?.$email;
    const dogName = event.detail.metaData?.["Dog Name"];

    const properties = btoa(
      JSON.stringify({ "Dog Name": dogName })
    )
    .replace(/\+/g, "-")
    .replace(/\//g, "_")
    .replace(/=+$/, "");

    window.location.href =
      `/cart/${freeJarVariantId}:1` +
      `?properties=${properties}` +
      `&checkout[email]=${encodeURIComponent(email)}`;

  }

});




// Automatically checks the founder_pricing checkbox
(function () {
  function checkFounderPricingBox() {
    const checkbox = document.querySelector('input[type="checkbox"][name^="founder_pricing_40"]');
    if (checkbox && !checkbox.checked) {
      checkbox.checked = true;
      checkbox.dispatchEvent(new Event('change', { bubbles: true }));
      checkbox.dispatchEvent(new Event('input', { bubbles: true }));
      return true;
    }
    return false;
  }

  if (checkFounderPricingBox()) return;

  const observer = new MutationObserver(() => {
    if (checkFounderPricingBox()) {
      observer.disconnect();
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });

  setTimeout(() => observer.disconnect(), 15000);
})();



// benefit items - active state as each item nears the vertical middle of the viewport
const benefitItems = document.querySelectorAll('.benefits__item');
if (benefitItems.length) {
  benefitItems.forEach((item) => {
    ScrollTrigger.create({
      trigger: item,
      start: 'top center+=10%',
      end: 'bottom center-=10%',
      toggleClass: { targets: item, className: 'benefits__item--active' }
    });
  });
}





// Product Hero - Flickity slider
// Re-initialized on 'shopify:section:load' so the slider keeps working after
// the theme editor swaps in fresh section HTML (which never re-runs this script).
let productHeroSlider, productHeroSliderNav, productHeroFlickityMain, productHeroFlickityNav, productHeroNavOptions;
const productHeroMobileQuery = window.matchMedia('screen and (max-width: 767px) and (orientation: portrait)');
let productHeroNavWasHidden = productHeroMobileQuery.matches;
let productHeroResizeTimeout;

function initProductHeroSlider(root) {
  root = root || document;
  const slider = root.querySelector('.product-hero__slider');
  const sliderNav = root.querySelector('.product-hero__slider-nav');
  if (!slider || !sliderNav || typeof Flickity === 'undefined') return;

  if (productHeroFlickityMain) productHeroFlickityMain.destroy();
  if (productHeroFlickityNav) productHeroFlickityNav.destroy();

  productHeroSlider = slider;
  productHeroSliderNav = sliderNav;

  productHeroFlickityMain = new Flickity(productHeroSlider, {
    cellSelector: '.product-hero__slide',
    pageDots: false,
    wrapAround: true,
    prevNextButtons: false,
    contain: true,
    imagesLoaded: true
  });
  productHeroNavOptions = {
    cellSelector: '.product-hero__slide',
    asNavFor: productHeroSlider,
    contain: true,
    pageDots: false,
    prevNextButtons: true,
    groupCells: 5,
    imagesLoaded: true
  };
  productHeroFlickityNav = new Flickity(productHeroSliderNav, productHeroNavOptions);

  productHeroSlider.addEventListener('rimg:load', () => {
    productHeroFlickityMain.resize();
    productHeroFlickityNav.resize();
  });

  productHeroNavWasHidden = productHeroMobileQuery.matches;

  productHeroFlickityMain.on('staticClick', (event, pointer, cellElement) => {
    if (cellElement) {
      productHeroFlickityMain.next();
    }
  });
}

initProductHeroSlider();

window.addEventListener('resize', () => {
  clearTimeout(productHeroResizeTimeout);
  productHeroResizeTimeout = setTimeout(() => {
    if (!productHeroFlickityMain || !productHeroFlickityNav) return;
    const isHidden = productHeroMobileQuery.matches;
    if (productHeroNavWasHidden && !isHidden) {
      productHeroFlickityNav.destroy();
      productHeroFlickityNav = new Flickity(productHeroSliderNav, productHeroNavOptions);
    } else {
      productHeroFlickityMain.resize();
      productHeroFlickityNav.resize();
    }
    productHeroNavWasHidden = isHidden;
  }, 150);
});

document.addEventListener('shopify:section:load', (event) => {
  initProductHeroSlider(event.target);
});


// Plan Selector - day supply sync
// Maps dog size (1 = under 25 lbs, 2 = 25-75 lbs, 3 = over 75 lbs) to:
//  - days:  how many days each jar tier (index 0 = 1 jar, 1 = 2 jars, 2 = 3 jars) lasts for that dog size
//  - plans: the variant + selling plan to add to cart for each jar tier ("1" | "2" | "3")
//           (variantId/sellingPlanId are placeholders - to be hardcoded later)

const subscriptionProduct1JarVariant = 59804307915038;
const subscriptionProduct2JarVariant = 59804307947806;
const subscriptionProduct3JarVariant = 59804307980574;

// founder variants and selling plans for coming soon
const founderStarterSubscription1JarVariant = 59819466686750;
const founderStarterSubscription2JarVariant = 59819466719518;
const founderStarterSubscription3JarVariant = 59819466752286;
const founderSellingPlan20days = 10072686878;
const founderSellingPlan30days = 10072719646;
const founderSellingPlan40days = 10072752414;
const founderSellingPlan60days = 10072785182;
const founderSellingPlan90days = 10072817950;
const founderSellingPlan120days = 10072850718;
const founderSellingPlan180days = 10072883486;

// regular variants and selling plans for product page
const regularStarterSubscription1JarVariant = 59928713953566;
const regularStarterSubscription2JarVariant = 59928713986334;
const regularStarterSubscription3JarVariant = 59928714019102;
const regularSellingPlan20days = 10141106462;
const regularSellingPlan30days = 10141139230;
const regularSellingPlan40days = 10141171998;
const regularSellingPlan60days = 10141204766;
const regularSellingPlan90days = 10141237534;
const regularSellingPlan120days = 10141270302;
const regularSellingPlan180days = 10141303070;

var founderPlanDetails = {
  "1": {
    "days": [60, 120, 180],
    "plans": {
      "1": { "variantId": founderStarterSubscription1JarVariant, "sellingPlanId": founderSellingPlan60days },
      "2": { "variantId": founderStarterSubscription2JarVariant, "sellingPlanId": founderSellingPlan120days },
      "3": { "variantId": founderStarterSubscription3JarVariant, "sellingPlanId": founderSellingPlan180days }
    }
  },
  "2": {
    "days": [30, 60, 90],
    "plans": {
      "1": { "variantId": founderStarterSubscription1JarVariant, "sellingPlanId": founderSellingPlan30days },
      "2": { "variantId": founderStarterSubscription2JarVariant, "sellingPlanId": founderSellingPlan60days },
      "3": { "variantId": founderStarterSubscription3JarVariant, "sellingPlanId": founderSellingPlan90days }
    }
  },
  "3": {
    "days": [20, 40, 60],
    "plans": {
      "1": { "variantId": founderStarterSubscription1JarVariant, "sellingPlanId": founderSellingPlan20days },
      "2": { "variantId": founderStarterSubscription2JarVariant, "sellingPlanId": founderSellingPlan40days },
      "3": { "variantId": founderStarterSubscription3JarVariant, "sellingPlanId": founderSellingPlan60days }
    }
  }
};

// regular variants and selling plans for product-hero.liquid (product page)
var regularPlanDetails = {
  "1": {
    "days": [60, 120, 180],
    "plans": {
      "1": { "variantId": regularStarterSubscription1JarVariant, "sellingPlanId": regularSellingPlan60days },
      "2": { "variantId": regularStarterSubscription2JarVariant, "sellingPlanId": regularSellingPlan120days },
      "3": { "variantId": regularStarterSubscription3JarVariant, "sellingPlanId": regularSellingPlan180days }
    }
  },
  "2": {
    "days": [30, 60, 90],
    "plans": {
      "1": { "variantId": regularStarterSubscription1JarVariant, "sellingPlanId": regularSellingPlan30days },
      "2": { "variantId": regularStarterSubscription2JarVariant, "sellingPlanId": regularSellingPlan60days },
      "3": { "variantId": regularStarterSubscription3JarVariant, "sellingPlanId": regularSellingPlan90days }
    }
  },
  "3": {
    "days": [20, 40, 60],
    "plans": {
      "1": { "variantId": regularStarterSubscription1JarVariant, "sellingPlanId": regularSellingPlan20days },
      "2": { "variantId": regularStarterSubscription2JarVariant, "sellingPlanId": regularSellingPlan40days },
      "3": { "variantId": regularStarterSubscription3JarVariant, "sellingPlanId": regularSellingPlan60days }
    }
  }
};

// coming-soon-hero.liquid and product-hero.liquid share identical DOM hooks
// (#product-hero, .product-hero__product-radio, .founder-subscribe, etc.), so
// this checks data-section-type on whichever one is actually on the page to
// pick founder vs. regular variants/selling plans - only one is ever present.
function getActivePlanDetails() {
  var heroSection = document.querySelector('[data-section-type="coming-soon-hero"], [data-section-type="product-hero"]');
  return (heroSection && heroSection.dataset.sectionType === 'product-hero')
    ? regularPlanDetails
    : founderPlanDetails; // default to founder if neither is found, matching prior behavior
}

function getPlanDaysForJarTier(dogSize, jarTier) {
  var sizeConfig = getActivePlanDetails()[String(dogSize)];
  if (!sizeConfig) return null;
  var dayIndex = Number(jarTier) - 1;
  return sizeConfig.days[dayIndex];
}

function getPlanDetailsForSelection(dogSize, jarTier) {
  var sizeConfig = getActivePlanDetails()[String(dogSize)];
  if (!sizeConfig) return null;
  return sizeConfig.plans[String(jarTier)] || null;
}

const planDaySupplyEls = document.querySelectorAll('[data-plan-days]');

function updatePlanDaySupply(dogSize) {
  if (!planDaySupplyEls.length) return;
  planDaySupplyEls.forEach(function (el) {
    var jarTier = el.dataset.planDays;
    var days = getPlanDaysForJarTier(dogSize, jarTier);
    if (days != null) {
      el.textContent = days + '-Day Supply';
    }
  });
}

// ============================================================
// Cross-Widget Sync — Dog Size & Jar Tier (single source of truth)
// ------------------------------------------------------------
// Three widgets let the shopper pick "dog size" and/or "jar tier / supply
// length", each with its own markup + vocabulary:
//   - .weight-selector                       -> numeric "1"|"2"|"3"   (dog size)
//   - .product-hero__product-radio       -> numeric "1"|"2"|"3"   (jar tier)
//   - .sticky-product-widget [data-dog-size]  -> numeric "1"|"2"|"3"  (dog size, bridged via Liquid data attrs)
//   - .sticky-product-widget [data-jar-tier]  -> numeric "1"|"2"|"3"  (jar tier, bridged via Liquid data attrs)
//
// setDogSize(value) / setJarTier(value) are the ONLY functions allowed to
// write to more than one widget's DOM. Every event handler below (range
// input, icon/label click, radio change, sticky-widget option click) calls
// INTO one of these two functions instead of reaching into a sibling widget
// directly - event -> setX() -> [DOM writes], never widget-A -> widget-B -> widget-A.
// Each setX() also short-circuits if the value hasn't actually changed.
// ============================================================

let currentDogSize = null;
let currentJarTier = null;

const dogSizeWeightText = { '1': 'under 25 pounds', '2': '25 to 75 pounds', '3': 'over 75 pounds' };
const dogSizeStickyLabel = { '1': 'UNDER 25 LBS', '2': '25–75 LBS', '3': 'OVER 75 LBS' };

// ------------------------------------------------------------
// Weight Selector - tail wag (Web Animations API)
// Wags a dog icon's tail whenever its .icon-btn becomes the active
// (selected) size, driven by setDogSize() below - not by click, so it
// stays correct no matter which widget changed the dog size.
// ------------------------------------------------------------
const TAIL_REST_ANGLE = 0;   // matches the resting rotation set in bk-styles.css

// Per-size wag specs from design: "Total Round-Trip Rotation" is the full
// peak-to-peak swing (so amplitude is half of it), "Loop Keyframe Count" is
// converted to a loop duration assuming 60fps (count / 60 * 1000ms). `duration`
// is the time for one full rest->peak->trough->rest cycle (see TAIL_WAG_CURVE).
const TAIL_WAG_CONFIG = {
  '1': { amplitude: 28 / 2, duration: 20 / 60 * 1000 }, // small: 28°, 18 keyframes @60fps = 300ms
  '2': { amplitude: 45 / 2, duration: 30 / 60 * 1000 }, // medium: 35°, 30 keyframes @60fps = 500ms
  '3': { amplitude: 32 / 2, duration: 24 / 60 * 1000 }  // large: 32°, 24 keyframes @60fps = 400ms
};

// Shape of one wag loop cycle, eyeballed from the AE graph-editor export (fast rise to
// peak, slower swing through center into a deeper trough, easing back to rest) - offsets
// are fractions of one loop's duration; tune these against the AE reference if needed.
const TAIL_WAG_CURVE = {
  peakOffset: 0.2,     // frame ~6/30 in the AE graph
  troughOffset: 0.65,  // frame ~20/30 in the AE graph
  riseEasing: 'cubic-bezier(0.16, 1, 0.3, 1)',     // quick, decelerating into the peak cubic-bezier(0.16, 1, 0.3, 1)
  fallEasing: 'cubic-bezier(.66,.5,1,1)',    // smooth traverse through center to the trough cubic-bezier(0.45, 0, 0.55, 1)
  returnEasing: 'cubic-bezier(0.33, 1, 0.68, 1)'   // gentle settle back to rest
};

const tailControllers = new Map(); // .icon-btn -> { setActive }

function getTailRotation(el) {
  const transform = getComputedStyle(el).transform;
  if (transform === 'none') return TAIL_REST_ANGLE;
  const matrix = new DOMMatrixReadOnly(transform);
  return Math.atan2(matrix.b, matrix.a) * (180 / Math.PI);
}

function createTailController(tailEl, amplitude, loopDuration) {
  let currentAnim = null;
  let isActive = false;

  function startWag() {
    const current = getTailRotation(tailEl);
    if (currentAnim) currentAnim.cancel();

    const enter = tailEl.animate(
      [
        { transform: `rotate(${current}deg)` },
        { transform: `rotate(${TAIL_REST_ANGLE}deg)` }
      ],
      { duration: 220, easing: 'ease-in-out', fill: 'forwards' }
    );
    currentAnim = enter;

    enter.finished.then(function () {
      if (currentAnim !== enter) return; // interrupted before it landed
      currentAnim = tailEl.animate(
        [
          { transform: `rotate(${TAIL_REST_ANGLE}deg)`, offset: 0, easing: TAIL_WAG_CURVE.riseEasing },
          { transform: `rotate(${amplitude}deg)`, offset: TAIL_WAG_CURVE.peakOffset, easing: TAIL_WAG_CURVE.fallEasing },
          { transform: `rotate(${-amplitude}deg)`, offset: TAIL_WAG_CURVE.troughOffset, easing: TAIL_WAG_CURVE.returnEasing },
          { transform: `rotate(${TAIL_REST_ANGLE}deg)`, offset: 1 }
        ],
        { duration: loopDuration, iterations: Infinity }
      );
    }).catch(function () {});
  }

  function stopWag() {
    const current = getTailRotation(tailEl);
    if (currentAnim) currentAnim.cancel();

    currentAnim = tailEl.animate(
      [
        { transform: `rotate(${current}deg)` },
        { transform: `rotate(${TAIL_REST_ANGLE}deg)` }
      ],
      { duration: 350, easing: 'ease-out', fill: 'forwards' }
    );
  }

  return {
    setActive: function (active) {
      if (active === isActive) return;
      isActive = active;
      active ? startWag() : stopWag();
    }
  };
}

function setDogSize(value) {
  value = String(value);
  if (!dogSizeWeightText[value]) return;
  if (currentDogSize === value) return;
  currentDogSize = value;

  // 1) Weight Selector - range + icon/label buttons
  const weightRange = document.getElementById('dog-size');
  if (weightRange) {
    weightRange.value = value;
    weightRange.setAttribute('aria-valuetext', dogSizeWeightText[value]);
    document.querySelectorAll('.weight-selector .icon-btn').forEach(function (btn) {
      const isActive = btn.dataset.value === value;
      btn.classList.toggle('active', isActive);
      const tailCtrl = tailControllers.get(btn);
      if (tailCtrl) { tailCtrl.setActive(isActive); }
    });
    document.querySelectorAll('.weight-selector .label-btn').forEach(function (btn) {
      btn.classList.toggle('active', btn.dataset.value === value);
    });
  }

  // 2) Sticky widget - dog-size dropdown
  const dogSizeField = document.querySelector('.dropdown-field[data-field="dogSize"]');
  if (dogSizeField) {
    const option = dogSizeField.querySelector('[data-dog-size="' + value + '"]');
    if (option) {
      dogSizeField.querySelectorAll('[role="option"]').forEach(function (o) { o.removeAttribute('aria-selected'); });
      option.setAttribute('aria-selected', 'true');
      const selectedLabel = dogSizeField.querySelector('[data-role="selected-label"]');
      if (selectedLabel) { selectedLabel.textContent = dogSizeStickyLabel[value]; }

      const selectedIcon = dogSizeField.querySelector('[data-role="selected-icon"]');
      const optionIcon = option.querySelector('.dropdown-option-icon');
      if (selectedIcon && optionIcon) { selectedIcon.innerHTML = optionIcon.innerHTML; }
    }
  }

  // 3) Downstream day-supply labels that depend on dog size
  updatePlanDaySupply(value);        // .product-hero__product-days spans
  updateStickySupplyLabels(value);   // sticky widget's supply <li> day-counts
}

function setJarTier(value) {
  value = String(value);
  if (!['1', '2', '3'].includes(value)) return;
  if (currentJarTier === value) return;
  currentJarTier = value;

  // 1) Coming Soon Hero jar-tier radios
  const radio = document.querySelector('.product-hero__product-radio[value="' + value + '"]');
  if (radio) { radio.checked = true; }

  // 2) Sticky widget - supply dropdown
  const supplyField = document.querySelector('.dropdown-field[data-field="supply"]');
  if (supplyField) {
    const option = supplyField.querySelector('[data-jar-tier="' + value + '"]');
    if (option) {
      supplyField.querySelectorAll('[role="option"]').forEach(function (o) { o.removeAttribute('aria-selected'); });
      option.setAttribute('aria-selected', 'true');
      const selectedLabel = supplyField.querySelector('[data-role="selected-label"]');
      if (selectedLabel) { selectedLabel.textContent = option.dataset.label; }

      const selectedPrice = supplyField.querySelector('[data-role="selected-price"]');
      const priceStrong = option.querySelector('.option-price strong');
      if (selectedPrice && priceStrong) { selectedPrice.textContent = priceStrong.textContent; }
    }
  }

  // 3) Founder-subscribe buttons (product-hero and the sticky widget both use this
  // class) - discounted/full price display
  const tierLabel = document.querySelector('.product-hero__product[data-jar-tier="' + value + '"]');
  const discountedPriceEl = tierLabel ? tierLabel.querySelector('.product-hero__product-discounted-price') : null;
  const fullPriceEl = tierLabel ? tierLabel.querySelector('.product-hero__product-price') : null;
  document.querySelectorAll('.founder-subscribe [data-cta-discounted-price]').forEach(function (el) {
    if (discountedPriceEl) { el.textContent = discountedPriceEl.textContent; }
  });
  document.querySelectorAll('.founder-subscribe [data-cta-compare-price]').forEach(function (el) {
    if (fullPriceEl) { el.textContent = fullPriceEl.textContent; }
  });
}

// When dog size changes, refresh the sticky widget's supply option day-counts
// from planDetails (reuses getPlanDaysForJarTier - no duplicated day-math).
function updateStickySupplyLabels(dogSize) {
  const supplyField = document.querySelector('.dropdown-field[data-field="supply"]');
  if (!supplyField) return;

  supplyField.querySelectorAll('[data-jar-tier]').forEach(function (option) {
    const jarTier = option.dataset.jarTier;
    const days = getPlanDaysForJarTier(dogSize, jarTier);
    if (days == null) return;

    const newLabelText = days + '-DAY SUPPLY';
    option.dataset.label = newLabelText;

    const textSpan = option.querySelector('span:last-child');
    if (textSpan) { textSpan.textContent = newLabelText; }

    if (option.getAttribute('aria-selected') === 'true') {
      const selectedLabel = supplyField.querySelector('[data-role="selected-label"]');
      if (selectedLabel) { selectedLabel.textContent = newLabelText; }
    }
  });
}


// Weight Selector
const weightSelector = document.querySelector('.weight-selector');
if (weightSelector) {
  const weightRange = weightSelector.querySelector('#dog-size');
  const weightIconBtns = weightSelector.querySelectorAll('.icon-btn');
  const weightLabelBtns = weightSelector.querySelectorAll('.label-btn');

  weightIconBtns.forEach(function (btn) {
    const tailEl = btn.querySelector('.tail');
    const config = TAIL_WAG_CONFIG[btn.dataset.value];
    if (tailEl && config) {
      tailControllers.set(btn, createTailController(tailEl, config.amplitude, config.duration));
    }
  });

  weightRange.addEventListener('input', () => setDogSize(weightRange.value));

  weightIconBtns.forEach(btn => btn.addEventListener('click', () => setDogSize(btn.dataset.value)));
  weightLabelBtns.forEach(btn => btn.addEventListener('click', () => setDogSize(btn.dataset.value)));

  // Initial sync: reconciles all three widgets to whatever the range's value is today.
  setDogSize(weightRange.value);
}

// Coming Soon Hero - Jar Tier radios
const jarTierRadios = document.querySelectorAll('.product-hero__product-radio');
if (jarTierRadios.length) {
  jarTierRadios.forEach(function (radio) {
    radio.addEventListener('change', function () {
      if (radio.checked) { setJarTier(radio.value); }
    });
  });

  // Initial sync: whichever radio is checked in the DOM today.
  const checkedJarTierRadio = document.querySelector('.product-hero__product-radio:checked');
  if (checkedJarTierRadio) { setJarTier(checkedJarTierRadio.value); }
}

// Sticky Product Widget - toggle open/closed
const stickyProductWidget = document.getElementById('sticky-product-widget');
const stickyProductWidgetToggles = document.querySelectorAll('.toggle-sticky-product-widget');
if (stickyProductWidget && stickyProductWidgetToggles.length) {
  stickyProductWidgetToggles.forEach(function (toggle) {
    toggle.addEventListener('click', function () {
      const isOpen = stickyProductWidget.dataset.status === 'open';
      stickyProductWidget.dataset.status = isOpen ? 'closed' : 'open';
    });
  });
}

// Sticky Product Widget - open it when a #product-widget link is clicked on mobile
const productWidgetLinks = document.querySelectorAll('a[href="#product-widget"]');
if (stickyProductWidget && productWidgetLinks.length) {
  const mobilePortraitQuery = window.matchMedia('screen and (max-width: 767px) and (orientation: portrait)');
  productWidgetLinks.forEach(function (link) {
    link.addEventListener('click', function () {
      if (mobilePortraitQuery.matches) {
        stickyProductWidget.dataset.status = 'open';
      }
    });
  });
}

// Sticky Product Widget - open when the #product-hero is off screen
const productHeroSection = document.getElementById('product-hero');
if (stickyProductWidget && productHeroSection) {
  ScrollTrigger.create({
    trigger: productHeroSection,
    start: 'bottom 60%',
    onEnter: function () {
      stickyProductWidget.dataset.status = 'open';
    },
    onLeaveBack: function () {
      stickyProductWidget.dataset.status = 'hidden';
    }
  });
}

// Sticky Product Widget - dropdown open/close (ported from its former inline
// <script>) + option selection (delegates to the shared setDogSize()/setJarTier()
// functions above instead of writing to a local state object).
document.querySelectorAll('.dropdown-field').forEach(function (field) {
  const fieldName = field.dataset.field; // "dogSize" | "supply"
  const trigger = field.querySelector('.dropdown-trigger');
  const panel = field.querySelector('.dropdown-panel');
  const options = field.querySelectorAll('[role="option"]');

  trigger.addEventListener('click', function () {
    const isOpen = trigger.getAttribute('aria-expanded') === 'true';
    trigger.setAttribute('aria-expanded', String(!isOpen));
    panel.hidden = isOpen;
  });

  options.forEach(function (option) {
    option.addEventListener('click', function () {
      if (fieldName === 'dogSize' && option.dataset.dogSize) {
        setDogSize(option.dataset.dogSize);
      } else if (fieldName === 'supply' && option.dataset.jarTier) {
        setJarTier(option.dataset.jarTier);
      }

      trigger.setAttribute('aria-expanded', 'false');
      panel.hidden = true;
    });
  });
});

// Close dropdowns when clicking outside
document.addEventListener('click', function (e) {
  document.querySelectorAll('.dropdown-field').forEach(function (field) {
    if (!field.contains(e.target)) {
      field.querySelector('.dropdown-trigger').setAttribute('aria-expanded', 'false');
      field.querySelector('.dropdown-panel').hidden = true;
    }
  });
});




// Coming Soon Hero - Plan Selector cart buttons
// Adds the selected subscription line item (and/or the free jar) to the cart via
// a standalone /cart/add.js fetch call, then redirects to checkout on success.

function cartGetSelectedDogSize() {
  const dogSizeInput = document.getElementById('dog-size');
  return dogSizeInput ? dogSizeInput.value : '2';
}

function cartGetSelectedJarTier() {
  const checkedRadio = document.querySelector('.product-hero__product-radio:checked');
  return checkedRadio ? checkedRadio.value : null;
}

function cartAddToCart(items) {

  // alert(JSON.stringify(items));

  // add items to cart
  return fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ items: items })
  }).then(function (response) {

    return response.json().then(function (data) {

      // throw any errors
      if (!response.ok) {
        const errorMessage = (data && (data.description || data.message)) || 'Something went wrong adding this to your cart.';
        throw new Error(errorMessage);
      }

      // early return for only Free Jar
      if(items.length == 1 && items[0].id == freeJarVariantId){
        return data;
      }

      // update cart with dog_size
      return fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          attributes: {
            dog_size: dogSizes[cartGetSelectedDogSize()],
            jar_count: cartGetSelectedJarTier()
          }
        })
      }).then(function (updateResponse) {

        return updateResponse.json().then(function (updatedCart) {
          if (!updateResponse.ok) {
            throw new Error('Something went wrong updating the cart.');
          }

          // console.log('Updated cart:', updatedCart);
          console.log('updatedCart.attributes.dog_size:', updatedCart.attributes.dog_size);

          return updatedCart;
        });

      });

    });

  });
}

function cartHandleAddToCartError(error) {
  console.error('Cart add error:', error);
  alert(error.message || 'Something went wrong adding this to your cart. Please try again.');
}

function cartRedirectToCheckout() {
  window.location.href = '/checkout';
}

const founderSubscribeButtons = document.querySelectorAll('.founder-subscribe');
founderSubscribeButtons.forEach(function (founderSubscribeButton) {
  founderSubscribeButton.addEventListener('click', function (event) {
    event.preventDefault();

    const includeFreeJar = founderSubscribeButton.dataset.includeFreeJar === 'true' ? true : false;
    const dogSize = cartGetSelectedDogSize();
    const jarTier = cartGetSelectedJarTier();
    const selectedPlan = jarTier ? getPlanDetailsForSelection(dogSize, jarTier) : null;

    if (!selectedPlan || !selectedPlan.variantId) {
      cartHandleAddToCartError(new Error('Please select a plan before subscribing.'));
      return;
    }

    const subscriptionItem = { id: selectedPlan.variantId, quantity: 1 };
    if (selectedPlan.sellingPlanId) {
      subscriptionItem.selling_plan = selectedPlan.sellingPlanId;
    }

    const itemsForCart = [subscriptionItem]
    if(includeFreeJar){
      itemsForCart.push({ id: freeJarVariantId, quantity: 1 })
    }
    
    cartAddToCart(itemsForCart)
      .then(cartRedirectToCheckout)
      .catch(cartHandleAddToCartError);
  });
});

const justFreeJarButtons = document.querySelectorAll('.just-free-jar');
justFreeJarButtons.forEach(function (justFreeJarButton) {
  justFreeJarButton.addEventListener('click', function (event) {
    event.preventDefault();

    cartAddToCart([
      { id: freeJarVariantId, quantity: 1 }
    ])
      .then(cartRedirectToCheckout)
      .catch(cartHandleAddToCartError);
  });
});



const dogSizes = {
  '1': 'small',
  '2': 'medium',
  '3': 'large'
};

// Static Reviews - autoplaying muted videos, click the overlay to restart with sound
const staticReviewsVideoWrappers = document.querySelectorAll('.static-reviews__video');
const staticReviewsAllVideos = [...staticReviewsVideoWrappers]
  .map(function (wrapper) { return wrapper.querySelector('.static-reviews__video-element'); })
  .filter(Boolean);

// Only one static-reviews video should ever be audibly/actively playing at a time -
// starting one pauses and resets any other that's still playing (including one quietly
// auto-looping muted in the background after its own sound-on playback already ended).
function stopOtherStaticReviewsVideos(exceptVideo) {
  staticReviewsAllVideos.forEach(function (otherVideo) {
    if (otherVideo === exceptVideo || otherVideo.paused) return;
    otherVideo.pause();
    otherVideo.currentTime = 0;
    otherVideo.muted = true;
    otherVideo.loop = true;
    otherVideo.controls = false;
    var otherWrapper = otherVideo.closest('.static-reviews__video');
    if (otherWrapper) otherWrapper.classList.remove('playing');
  });
}

// Visitors who've told their browser/OS they want less motion or less data get the
// click-to-play experience only - no scroll-triggered autoplay.
const staticReviewsAllowAutoplay = !window.matchMedia('(prefers-reduced-motion: reduce)').matches
  && !(navigator.connection && navigator.connection.saveData);

staticReviewsVideoWrappers.forEach(function (staticReviewsVideoWrapper) {
  const video = staticReviewsVideoWrapper.querySelector('.static-reviews__video-element');
  const playButton = staticReviewsVideoWrapper.querySelector('.static-reviews__video-play');
  if (!video || !playButton) return;

  video.disablePictureInPicture = true;
  video.setAttribute('controlsList', 'nodownload noplaybackrate noremoteplayback');

  // Shopify transcodes uploaded videos into an adaptive HLS stream (.m3u8) plus a flat
  // 1080p MP4 fallback. Only Safari can play the .m3u8 <source> natively - every other
  // browser would otherwise fall through to the heavier flat MP4. Use hls.js (loaded by
  // this section, see vendor.hls.min.js) to stream the same adaptive rendition there too.
  // Runs once, lazily, on first play - never before the visitor actually presses play.
  function attachVideoSourceThenReady(onReady) {
    if (video.dataset.sourceAttached) {
      onReady();
      return;
    }
    video.dataset.sourceAttached = 'true';

    if (video.canPlayType('application/vnd.apple.mpegurl')) {
      onReady();
      return;
    }

    var hlsSource = video.querySelector('source[type="application/x-mpegURL"]');
    if (hlsSource && window.Hls && Hls.isSupported()) {
      // Cap the streamed rendition to the video element's actual rendered size instead
      // of defaulting toward the highest (1080p) rendition - these cards are small, and
      // this matters even more once several can autoplay muted at the same time.
      var hls = new Hls({ capLevelToPlayerSize: true });
      hls.loadSource(hlsSource.src);
      hls.attachMedia(video);
      hls.on(Hls.Events.MANIFEST_PARSED, onReady);
    } else {
      onReady();
    }
  }

  function handlePlayButtonClick() {
    // The 'playing' class marks whichever video is the current sound-on selection,
    // whether it's actively playing or paused mid-way - it's only cleared when this
    // video ends naturally or another video interrupts it (see stopOtherStaticReviewsVideos).
    // So a click on the already-selected video toggles pause/resume in place, while a
    // click on any other video always (re)starts it from the beginning.
    if (staticReviewsVideoWrapper.classList.contains('playing')) {
      if (video.paused) {
        stopOtherStaticReviewsVideos(video);
        video.play();
      } else {
        video.pause();
      }
      return;
    }

    stopOtherStaticReviewsVideos(video);
    attachVideoSourceThenReady(function () {
      video.currentTime = 0;
      video.muted = false;
      video.volume = 1;
      video.controls = true;
      video.loop = false;
      video.play();
      staticReviewsVideoWrapper.classList.add('playing');
    });
  }

  function videoEnded() {
    video.currentTime = 0;
    video.muted = true;
    video.loop = true;
    video.play();
    video.controls = false;
    staticReviewsVideoWrapper.classList.remove('playing');
  }

  playButton.addEventListener('click', handlePlayButtonClick);
  video.addEventListener('ended', videoEnded);

  // Autoplay this video (muted, looping) whenever it scrolls into view, and pause it
  // when it scrolls back out. Skips a video the visitor already deliberately started
  // with sound (the 'playing' class) so autoplay doesn't fight that choice.
  if (staticReviewsAllowAutoplay && typeof IntersectionObserver !== 'undefined') {
    var staticReviewsVideoObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          if (staticReviewsVideoWrapper.classList.contains('playing')) return;
          attachVideoSourceThenReady(function () {
            video.play().catch(function () {});
          });
        } else {
          video.pause();
        }
      });
    }, { threshold: 0.5 });
    staticReviewsVideoObserver.observe(staticReviewsVideoWrapper);
  }
});

// Static Reviews - Flickity slider on mobile portrait only (70% cells, next/prev peek)
// Re-initialized on resize (breakpoint crossing) and 'shopify:section:load' (theme editor
// section reload), same reasoning as the Product Hero slider fix above.
let staticReviewsFlickity;
const staticReviewsMobileQuery = window.matchMedia('screen and (max-width: 767px) and (orientation: portrait)');

function initStaticReviewsSlider(root) {
  root = root || document;
  const videosContainer = root.querySelector('.static-reviews__videos');
  if (!videosContainer || typeof Flickity === 'undefined') return;

  if (staticReviewsFlickity) {
    staticReviewsFlickity.destroy();
    staticReviewsFlickity = null;
  }

  if (staticReviewsMobileQuery.matches) {
    staticReviewsFlickity = new Flickity(videosContainer, {
      cellSelector: '.static-reviews__video',
      cellAlign: 'center',
      pageDots: true,
      prevNextButtons: false,
      wrapAround: true,
      imagesLoaded: false
    });
  }
}

initStaticReviewsSlider();

let staticReviewsResizeTimeout;
window.addEventListener('resize', function () {
  clearTimeout(staticReviewsResizeTimeout);
  staticReviewsResizeTimeout = setTimeout(function () {
    initStaticReviewsSlider();
  }, 150);
});

document.addEventListener('shopify:section:load', function (event) {
  initStaticReviewsSlider(event.target);
});


// Static Ingredients - Flickity slider on mobile portrait only (70% cells, next/prev peek)
// Re-initialized on resize (breakpoint crossing) and 'shopify:section:load' (theme editor
// section reload), same reasoning as the Static Reviews slider above.
let staticIngredientsFlickity;
const staticIngredientsMobileQuery = window.matchMedia('screen and (max-width: 767px) and (orientation: portrait)');

function initStaticIngredientsSlider(root) {
  root = root || document;
  const itemsContainer = root.querySelector('.static-ingredients__items');
  if (!itemsContainer || typeof Flickity === 'undefined') return;

  if (staticIngredientsFlickity) {
    staticIngredientsFlickity.destroy();
    staticIngredientsFlickity = null;
  }

  var items = itemsContainer.querySelectorAll('.static-ingredients__item');
  items.forEach(function (item) { item.style.height = ''; });

  if (staticIngredientsMobileQuery.matches) {
    // Flickity absolutely positions cells to slide them, and a height:auto cell
    // collapses to 0 in that context - measure the tallest card's natural height
    // first and pin every cell to it before Flickity takes over.
    var maxHeight = 0;
    items.forEach(function (item) {
      maxHeight = Math.max(maxHeight, item.getBoundingClientRect().height);
    });
    items.forEach(function (item) {
      item.style.height = maxHeight + 'px';
    });

    staticIngredientsFlickity = new Flickity(itemsContainer, {
      cellSelector: '.static-ingredients__item',
      cellAlign: 'center',
      pageDots: true,
      prevNextButtons: false,
      wrapAround: true,
      imagesLoaded: true
    });
  }
}

initStaticIngredientsSlider();

let staticIngredientsResizeTimeout;
window.addEventListener('resize', function () {
  clearTimeout(staticIngredientsResizeTimeout);
  staticIngredientsResizeTimeout = setTimeout(function () {
    initStaticIngredientsSlider();
  }, 150);
});

document.addEventListener('shopify:section:load', function (event) {
  initStaticIngredientsSlider(event.target);
});


// Features Slider - Flickity slider on all breakpoints (3 cells + peek on desktop,
// 1 cell + peek on mobile via CSS cell width). Re-initialized on 'shopify:section:load';
// otherwise just resized on breakpoint changes since Flickity re-measures CSS cell widths.
let featuresSliderFlickity;
let featuresSliderResizeTimeout;

// Flickity absolutely positions cells to slide them, so a percentage/auto height can't
// resolve against the (otherwise auto-height) container - measure each cell's natural
// height in normal flow and pin every cell to the tallest one, same fix as the Static
// Ingredients slider above.
function pinFeaturesSliderHeights(itemsContainer) {
  var items = itemsContainer.querySelectorAll('.features-slider__item');
  items.forEach(function (item) { item.style.height = ''; });

  var maxHeight = 0;
  items.forEach(function (item) {
    maxHeight = Math.max(maxHeight, item.getBoundingClientRect().height);
  });
  items.forEach(function (item) {
    item.style.height = maxHeight + 'px';
  });
}

// Swap Flickity's auto-generated arrow icon for the site's own chevron (same one used
// by the dropdown toggles, see snippets/icon-dropdown-arrow.liquid), reusing its native
// right-pointing orientation for "next" and mirroring it via CSS for "previous".
var featuresSliderChevronSvg = '<svg class="flickity-button-icon" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 58 100"><polygon points="4.6 100 0 95.1 48.3 50 0 4.9 4.6 0 58 50 4.6 100"></polygon></svg>';
function replaceFeaturesSliderArrowIcons(itemsContainer) {
  var buttons = itemsContainer.querySelectorAll('.flickity-prev-next-button');
  buttons.forEach(function (button) {
    button.innerHTML = featuresSliderChevronSvg;
  });
}

function initFeaturesSlider(root) {
  root = root || document;
  const itemsContainer = root.querySelector('.features-slider__items');
  if (!itemsContainer || typeof Flickity === 'undefined') return;

  if (featuresSliderFlickity) {
    featuresSliderFlickity.destroy();
    featuresSliderFlickity = null;
  }

  pinFeaturesSliderHeights(itemsContainer);

  featuresSliderFlickity = new Flickity(itemsContainer, {
    cellSelector: '.features-slider__item',
    cellAlign: 'center',
    pageDots: true,
    prevNextButtons: true,
    wrapAround: true,
    imagesLoaded: false
  });

  replaceFeaturesSliderArrowIcons(itemsContainer);
}

initFeaturesSlider();

window.addEventListener('resize', function () {
  clearTimeout(featuresSliderResizeTimeout);
  featuresSliderResizeTimeout = setTimeout(function () {
    if (!featuresSliderFlickity) return;
    const itemsContainer = document.querySelector('.features-slider__items');
    if (itemsContainer) pinFeaturesSliderHeights(itemsContainer);
    featuresSliderFlickity.resize();
  }, 150);
});

document.addEventListener('shopify:section:load', function (event) {
  initFeaturesSlider(event.target);
});


// FAQ Categorized - category nav
// Re-initialized on 'shopify:section:load' so the nav keeps working after
// the theme editor swaps in fresh section HTML (which never re-runs this script).
function initFaqCategorizedNav(root) {
  root = root || document;
  const navItems = root.querySelectorAll('[data-faq-category]');
  if (!navItems.length) return;

  navItems.forEach(function (navItem) {
    navItem.addEventListener('click', function () {
      const categoryId = navItem.getAttribute('data-faq-category');

      navItems.forEach(function (item) {
        item.classList.remove('is-active');
      });
      navItem.classList.add('is-active');

      root.querySelectorAll('[data-faq-panel]').forEach(function (panel) {
        panel.hidden = panel.getAttribute('data-faq-panel') !== categoryId;
      });

      // Keep the URL hash in sync so the current category stays linkable/bookmarkable.
      // replaceState (not location.hash) avoids adding a history entry or triggering
      // the native hash-change scroll jump / our own hashchange listener below.
      const handle = navItem.getAttribute('data-faq-category-handle');
      if (handle) { history.replaceState(null, '', '#' + handle); }

      // Switching to a category with fewer/shorter questions can leave the page
      // scrolled past the end of its (now shorter) panel - scroll back to the
      // top of the section so the newly selected category is always in view.
      const section = document.querySelector('.faq-categorized');
      if (section) { section.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
    });
  });

  root.querySelectorAll('.faq-categorized__mobile-item').forEach(function (mobileItem) {
    mobileItem.addEventListener('toggle', function () {
      if (!mobileItem.open) return;
      const handle = mobileItem.getAttribute('data-faq-category-handle');
      if (handle) { history.replaceState(null, '', '#' + handle); }
    });
  });
}

initFaqCategorizedNav();

document.addEventListener('shopify:section:load', function (event) {
  initFaqCategorizedNav(event.target);
});

// Deep-link to a category via URL hash, e.g. /pages/faq#shipping-delivery-and-returns
// (uses the category's stable metaobject handle, not the numeric id used above).
function activateFaqCategoryFromHash() {
  const handle = window.location.hash.slice(1);
  if (!handle) return;

  // Desktop: reuse initFaqCategorizedNav's click handler instead of duplicating its logic
  const navItem = document.querySelector('[data-faq-category-handle="' + handle + '"][data-faq-category]');
  if (navItem) { navItem.click(); }

  // Mobile: open the matching <details> directly - it has no click handler of its own
  const mobileItem = document.querySelector('.faq-categorized__mobile-item[data-faq-category-handle="' + handle + '"]');
  if (mobileItem) { mobileItem.open = true; }

  if (navItem || mobileItem) {
    const section = document.querySelector('.faq-categorized');
    if (section) { section.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
  }
}

activateFaqCategoryFromHash();
window.addEventListener('hashchange', activateFaqCategoryFromHash);

// Ingredients List - Active/Inactive, Category, and Letter filters (each single-select,
// combined as AND). Re-initialized on 'shopify:section:load' like initFaqCategorizedNav.
function initIngredientsListFilters(root) {
  root = root || document;
  const section = root.querySelector('.ingredients-list');
  if (!section) return;

  const state = { active: null, category: null, letter: null, search: '' };
  const searchInput = section.querySelector('[data-filter-search]');
  const noResultsMessage = section.querySelector('[data-no-results]');

  function applyFilters() {
    let visibleCount = 0;
    section.querySelectorAll('[data-ingredient]').forEach(function (item) {
      const matchesActive = state.active === null || item.dataset.active === state.active;
      const matchesCategory = state.category === null || item.dataset.category === state.category;
      const matchesLetter = state.letter === null || item.dataset.letter === state.letter;
      const matchesSearch = state.search === '' || item.dataset.name.toLowerCase().indexOf(state.search) !== -1;
      const isVisible = matchesActive && matchesCategory && matchesLetter && matchesSearch;
      item.hidden = !isVisible;
      if (isVisible) { visibleCount++; }
    });

    section.querySelectorAll('[data-letter-group]').forEach(function (group) {
      group.hidden = !group.querySelector('[data-ingredient]:not([hidden])');
    });

    if (noResultsMessage) { noResultsMessage.hidden = visibleCount > 0; }
  }

  if (searchInput) {
    searchInput.addEventListener('input', function () {
      state.search = searchInput.value.trim().toLowerCase();
      applyFilters();
    });
  }

  function wireGroup(selector, stateKey) {
    const buttons = section.querySelectorAll(selector);
    buttons.forEach(function (button) {
      if (button.hasAttribute('data-disabled')) return;
      button.addEventListener('click', function () {
        const alreadyActive = button.classList.contains('is-active');
        buttons.forEach(function (btn) { btn.classList.remove('is-active'); });
        state[stateKey] = alreadyActive ? null : button.dataset.filterValue;
        if (!alreadyActive) { button.classList.add('is-active'); }
        applyFilters();
      });
    });
  }

  wireGroup('[data-filter-active]', 'active');
  wireGroup('[data-filter-category]', 'category');
  wireGroup('[data-filter-letter]', 'letter');

  // Keep the URL hash in sync with whichever ingredient is open, so the
  // address bar always holds a copyable direct link. replaceState (not
  // location.hash) avoids adding a history entry or triggering the native
  // hash-change scroll jump / our own hashchange listener below.
  section.querySelectorAll('[data-ingredient]').forEach(function (item) {
    item.addEventListener('toggle', function () {
      if (item.open) {
        history.replaceState(null, '', '#' + item.id);
      }
    });
  });
}

initIngredientsListFilters();
document.addEventListener('shopify:section:load', function (event) {
  initIngredientsListFilters(event.target);
});

// Ingredients List - open the linked ingredient's <details> when the page
// loads (or the hash changes) with a #<ingredient-name-handle> deep link.
function openIngredientFromHash() {
  const handle = window.location.hash.slice(1);
  if (!handle) return;

  const target = document.getElementById(handle);
  if (!target || target.tagName !== 'DETAILS') return;

  target.open = true;
  target.scrollIntoView({ behavior: 'smooth', block: 'start' });
}

openIngredientFromHash();
window.addEventListener('hashchange', openIngredientFromHash);

// Refer a Friend - submits directly to Klaviyo's public Client Subscription API
// (not the onsite embed widget used elsewhere) so the form and success/error
// states can be fully custom. Re-initialized on 'shopify:section:load' like
// the other filter/nav initializers above.
const KLAVIYO_COMPANY_ID = 'XgnSuB';
const KLAVIYO_REFER_A_FRIEND_LIST_ID = 'TJJBGS';

function initReferAFriendForm(root) {
  root = root || document;
  const section = root.querySelector('.refer-a-friend');
  if (!section) return;

  const form = section.querySelector('[data-refer-a-friend-form]');
  const submitButton = section.querySelector('[data-refer-a-friend-submit]');
  const errorEl = section.querySelector('[data-refer-a-friend-error]');
  const successEl = section.querySelector('[data-refer-a-friend-success]');
  const copyButton = section.querySelector('[data-refer-a-friend-copy]');
  const discountCode = section.dataset.discountCode || '';
  if (!form) return;

  form.addEventListener('submit', function (event) {
    event.preventDefault();

    if (errorEl) { errorEl.hidden = true; errorEl.textContent = ''; }
    if (submitButton) { submitButton.disabled = true; }

    const formData = new FormData(form);
    const email = (formData.get('email') || '').toString().trim();
    const firstName = (formData.get('first_name') || '').toString().trim();
    const lastName = (formData.get('last_name') || '').toString().trim();
    const referredBy = (formData.get('referred_by') || '').toString().trim();

    fetch('https://a.klaviyo.com/client/subscriptions?company_id=' + KLAVIYO_COMPANY_ID, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/vnd.api+json',
        'Accept': 'application/vnd.api+json',
        'revision': '2026-07-15'
      },
      body: JSON.stringify({
        data: {
          type: 'subscription',
          attributes: {
            custom_source: 'Refer a Friend',
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email: email,
                  first_name: firstName,
                  last_name: lastName,
                  properties: { referred_by: referredBy },
                  subscriptions: {
                    email: {
                      marketing: { consent: 'SUBSCRIBED' }
                    }
                  }
                }
              }
            }
          },
          relationships: {
            list: {
              data: { type: 'list', id: KLAVIYO_REFER_A_FRIEND_LIST_ID }
            }
          }
        }
      })
    }).then(function (response) {
      if (!response.ok) { throw new Error('Something went wrong. Please try again.'); }

      form.hidden = true;
      if (successEl) { successEl.hidden = false; }
    }).catch(function () {
      if (submitButton) { submitButton.disabled = false; }
      if (errorEl) {
        errorEl.textContent = 'Something went wrong submitting the form. Please try again.';
        errorEl.hidden = false;
      }
    });
  });

  if (copyButton) {
    copyButton.addEventListener('click', function () {
      if (!navigator.clipboard) return;
      navigator.clipboard.writeText(discountCode).then(function () {
        const originalText = copyButton.textContent;
        copyButton.textContent = 'Copied!';
        setTimeout(function () { copyButton.textContent = originalText; }, 2000);
      }).catch(function () {});
    });
  }
}

initReferAFriendForm();
document.addEventListener('shopify:section:load', function (event) {
  initReferAFriendForm(event.target);
});
